class Breadcrumbs {
    constructor() {
        // global class identifier
        this.class = {
            lorem: '.js-lorem',
            breadcrumb: '.js__breadcrumb',
            breadcrumbButton: '.js__breadcrumb-btn',
            breadcrumbCurrentItem: '.js__breadcrumb-current-item',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    /**
     * Adding event handler
     */
    addBreadcrumbEventHandler() {
        const breadcrumbButton = document.querySelector(this.class.breadcrumbButton);

        if (breadcrumbButton) {
            // Register Eventhandler
            breadcrumbButton.addEventListener('click', (e) => this.handleBreadcrumbBehavior(e));
        }
    }

    /**
     * Toggle visibility of current breadcrumb item
     */
    handleBreadcrumbBehavior(e) {
        const breadcrumb = document.querySelector(this.class.breadcrumb);
        let firstElement = {};
        const lastElement = document.querySelector(this.class.breadcrumbCurrentItem);

        // Toggle button
        e.currentTarget.classList.toggle('d-none');

        // Add startpage eventlistener
        if (window.getComputedStyle(e.currentTarget).visibility !== 'hidden') {
            firstElement = breadcrumb.querySelector('.breadcrumb-item').firstChild;
            firstElement.addEventListener('click', (e) => this.showInitialState(e));
        }

        // Change flex direction
        if (breadcrumb && breadcrumb.classList.contains('collapsed')) {
            breadcrumb.classList.remove('collapsed');
        } else {
            breadcrumb.classList.add('collapsed');
        }

        // Toggle last breadcrumb item
        if (lastElement && lastElement.classList.contains('hidden')) {
            lastElement.classList.remove('hidden');
            lastElement.classList.remove('d-none');
        } else {
            lastElement.classList.add('hidden');
            lastElement.classList.add('d-none');
        }
    }

    /**
     * Reset breadcrumb to initial state
     */
    showInitialState(e) {
        e.preventDefault();

        const breadcrumb = document.querySelector(this.class.breadcrumb);
        const breadcrumbButton = document.querySelector(this.class.breadcrumbButton);

        // Call event
        breadcrumbButton.click();

        // Reset flex-direction to row
        if (breadcrumb && breadcrumb.classList.contains('collapsed')) {
            breadcrumb.classList.remove('collapsed');
        }

        // Enable startpage link default behavior
        e.currentTarget.removeEventListener('click', null);
    }

    /**
     * Initialize breadcrumb functions
     */
    init() {
        this.addBreadcrumbEventHandler();
    }
}

export default new Breadcrumbs();
